import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_zoomin",
  "use": "icon-map_zoomin-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_zoomin\">\n<g id=\"icon-map_zoomin_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 15 16 L 16 15 C 13.964844 10.683594 14.789063 3.644531 9.941406 1.359375 C 3.601563 -1.621094 -2 6.589844 2.519531 11.683594 C 5.429688 15 11.207031 14 15 16 M 7 2.660156 C 12.65625 2.085938 13.261719 10.640625 7.957031 11.621094 C 1.605469 12.800781 0.953125 3.28125 7 2.660156 M 4 7 L 4 8 L 11 8 C 8.667969 7.015625 6.542969 7.019531 4 7 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_zoomin.svg
// module id = BnnX
// module chunks = 24